import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Button, Space, Spin } from 'antd';

import { SubscriptionCard } from 'entities/subscription/ui/SubscriptionCard/SubscriptionCard';
import { useUserSubscriptionsQuery } from 'entities/tariff/api';
import { useAuthorization } from 'entities/user/hooks/useAuthorization';
import {
	CenteredContainerStyled,
	HeadingStyled,
	MySubscriptionsHeaderStyled,
	TextStyled,
} from 'features/show-subscriptions/ui/MySubscription.styles';
import { SubscriptionsManagementLoadingContainerStyled } from 'pages/subscriptions-management/ui/SubscriptionsManagement/SubscriptionsManagement.styles';
import { ErrorImage } from 'shared/ui/ErrorImage';

export const MySubscriptions: FC = () => {
	const { t } = useTranslation();
	const authorization = useAuthorization();
	const { data: subscriptionsInfo, refetch, isLoading } = useUserSubscriptionsQuery();

	// eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
	if (!subscriptionsInfo || isLoading) {
		return (
			<SubscriptionsManagementLoadingContainerStyled>
				<Spin />
			</SubscriptionsManagementLoadingContainerStyled>
		);
	}
	if (!subscriptionsInfo.subscriptions.length) {
		return (
			<div style={{ width: `100%` }}>
				<MySubscriptionsHeaderStyled>{t(`Marketplace_Subscription_Management`)}</MySubscriptionsHeaderStyled>
				<CenteredContainerStyled>
					<ErrorImage src='https://cdn.dodostatic.net/static/marketplace/no-active-subscriptions-new' />
					<HeadingStyled>{t(`Marketplace_No_Active_Subscriptions`)}</HeadingStyled>
					<TextStyled>
						{t(`Marketplace_No_Active_Subscriptions_Text_1`)}
						{` `}
						{t(`Marketplace_No_Active_Subscriptions_Text_2`)}
					</TextStyled>
					<Link to='/'>
						<Button type='primary' size='large'>
							{t(`Marketplace_Choose_Application`)}
						</Button>
					</Link>
				</CenteredContainerStyled>
			</div>
		);
	}

	return (
		<div style={{ width: `100%` }}>
			<MySubscriptionsHeaderStyled>{t(`Marketplace_Subscription_Management`)}</MySubscriptionsHeaderStyled>
			<Space direction='vertical' style={{ width: `100%` }} size='middle'>
				{subscriptionsInfo.subscriptions.map(n => (
					<SubscriptionCard
						key={n.subscriptionId}
						subscription={n}
						removeFromTable={refetch}
						refetch={refetch}
						isOwned={n.purchaserLogin === authorization?.login}
					/>
				))}
			</Space>
		</div>
	);
};
